import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div className="footer" id="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-12">
              <img
                className="img-fluid"
                src={require("./../../assets/images/logo/footer-logo.png")}
                alt=""
              />
            </div>
            <div className="col-lg-4 col-12 pt-1">
              <form className="d-flex subscribe-form" role="search">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter your email address"
                  aria-label="Search"
                />
                <button className="btn" type="submit">
                  Subscribe
                </button>
              </form>
              {/* <p className="subscribe-lebel mt-3">
              Sign up for a free demo to see SmartOffice in action
              </p> */}
              <p className="subscribe-lebel mt-3">
              </p>
            </div>
          </div>
        </div>
        <div className="container py-3">
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="smartOffice">
                <h4 className="footer-heading">SmartOffice</h4>
                <ul>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  {/* <li>
                    <Link to="#">Mission & Vision</Link>
                  </li>
                  <li>
                    <Link to="#">Career</Link>
                  </li> */}
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                  {/* <li>
                    <Link to="customers">Customers</Link>
                  </li>
                  <li>
                    <Link to="#">Schedule a Demo</Link>
                  </li>
                  <li>
                    <Link to="#">Site Map</Link>
                  </li> */}
                  <li>
                    <Link to="pricing">Pricing</Link>
                  </li>
                </ul>
              </div>
              <div className="helpCenter">
                <h4 className="footer-heading">Help Center</h4>
                <ul>
                  <li>
                    <Link to="/technical-support">Technical Support</Link>
                  </li>
                  <li>
                    <Link to="/billing">Billing</Link>
                  </li>
                  <li>
                    <Link to="/sales">Sales</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="futures">
                <h4 className="footer-heading">Features</h4>
                <ul>
                  <li>
                    <Link to="/smart-people/payroll-management">Payroll</Link>
                  </li>
                  <li>
                    <Link to="/smart-people/shift-management">
                      Shift Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/smart-people/attendance-management">
                      Attendance Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/smart-people/tax-management">Tax Management</Link>
                  </li>
                  <li>
                    <Link to="/smart-people/leave-management">
                      Leave Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/smart-people/employee-management">
                      Employee Management
                    </Link>
                  </li>
                  <li>
                    <Link to="/smart-people/digital-notice-board">
                      Digital Notice Board
                    </Link>
                  </li>
                  <li>
                    <Link to="/smart-people/domain-customization">
                      Domain Customization
                    </Link>
                  </li>
                  <li>
                    <Link to="/smart-people/notification">Custom Notification</Link>
                  </li>
                  <li>
                    <Link to="/smart-people/organogram-management">Organogram Management</Link>
                  </li>
                  <li>
                    <Link to="/smart-people/company-management">Company Management</Link>
                  </li>
                  
                  
                </ul>
              </div>
              <div className="futures">
                <h4 className="footer-heading">Devices</h4>
                <ul>
                  <li>
                    <Link to="/devicepage">ZKT</Link>
                  </li>
                  
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="app">
                <h4 className="footer-heading">Apps</h4>
                <ul>
                  <li>
                    <Link to="/smart-people">SmartPeople</Link>
                  </li>
                  {/* <li>
                    <Link to="#">SmartDesk</Link>
                  </li>
                  <li>
                    <Link to="#">SmartBook</Link>
                  </li>
                  <li>
                    <Link to="#">SmartAsset</Link>
                  </li> */}
                </ul>
              </div>

              <div className="compare">
                <h4 className="footer-heading">Compare</h4>
                <ul>
                  <li>
                  <Link to="/compare-with-rippling">Vs. Rippling</Link>
                  </li>
                  {/* <li>
                    <Link to="#">VS ADP</Link>
                  </li>
                  <li>
                    <Link to="#">VS PiHR</Link>
                  </li>
                  <li>
                    <Link to="#">VS BambooHR</Link>
                  </li> */}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="resource">
                <h4 className="footer-heading">Resources</h4>
                <ul>
                  <li>
                    <Link to="/blog">Blog</Link>
                  </li>
                  {/* <li>
                    <Link to="/api-documentation">API Documentation</Link>
                  </li>
                  <li>
                    <Link to="/product-training">Product Training</Link>
                  </li> */}
                  <li>
                    <Link to="faq">FAQ</Link>
                  </li>
                  {/* <li>
                    <Link to="#">SmartAcademy</Link>
                  </li> */}
                </ul>
              </div>
              {/* <div className="partners">
                <h4 className="footer-heading">Partners</h4>
                <ul>
                  <li>
                    <Link to="#">Sales Partner</Link>
                  </li>
                  <li>
                    <Link to="#">Marketing Partner</Link>
                  </li>
                  <li>
                    <Link to="#">Integration Partner</Link>
                  </li>
                </ul>
              </div> */}
              <div className="legal">
                <h4 className="footer-heading">Legal</h4>
                <ul>
                  <li>
                    <Link to="/privacy-policy">Privacy & Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-condition">Terms & Condition</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="tiny_footer bg-primary-subtle">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <p className="text-start">
                  © {new Date().getFullYear()} SmartOffice. All Rights Reserved
                </p>
              </div>
              <div className="col-lg-6">
                <ul className="social">
                  <li>
                    <Link to="#">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.7498 12.6413C21.745 15.0234 20.8708 17.3218 19.2913 19.1049C17.7119 20.8881 15.5358 22.0334 13.1717 22.3257C13.119 22.3309 13.0657 22.3251 13.0153 22.3087C12.9649 22.2923 12.9184 22.2657 12.8788 22.2304C12.8392 22.1952 12.8073 22.1522 12.7851 22.1041C12.7629 22.0559 12.7509 22.0037 12.7498 21.9507V14.8913H14.9998C15.1024 14.8915 15.2039 14.8707 15.2981 14.8301C15.3923 14.7895 15.4772 14.73 15.5475 14.6553C15.6178 14.5807 15.672 14.4923 15.7068 14.3959C15.7416 14.2994 15.7563 14.1968 15.7498 14.0944C15.7333 13.9005 15.6437 13.7201 15.4993 13.5896C15.3549 13.4591 15.1663 13.3882 14.9717 13.3913H12.7498V11.1413C12.7498 10.7435 12.9079 10.362 13.1892 10.0807C13.4705 9.79935 13.852 9.64132 14.2498 9.64132H15.7498C15.8524 9.64152 15.9539 9.62068 16.0481 9.58009C16.1423 9.53951 16.2272 9.48003 16.2975 9.40534C16.3678 9.33066 16.422 9.24235 16.4568 9.14587C16.4916 9.0494 16.5063 8.94681 16.4998 8.84444C16.4833 8.65051 16.3937 8.47009 16.2493 8.33959C16.1049 8.20909 15.9163 8.13824 15.7217 8.14132H14.2498C13.4542 8.14132 12.6911 8.45739 12.1285 9.02C11.5659 9.58261 11.2498 10.3457 11.2498 11.1413V13.3913H8.99985C8.89729 13.3911 8.79577 13.412 8.70158 13.4525C8.60739 13.4931 8.52253 13.5526 8.45223 13.6273C8.38194 13.702 8.32771 13.7903 8.2929 13.8868C8.25809 13.9832 8.24344 14.0858 8.24985 14.1882C8.26644 14.3821 8.35598 14.5625 8.5004 14.693C8.64481 14.8235 8.83336 14.8944 9.02797 14.8913H11.2498V21.9507C11.2501 22.0033 11.2393 22.0553 11.2182 22.1034C11.197 22.1515 11.166 22.1947 11.1271 22.2301C11.0882 22.2654 11.0423 22.2922 10.9924 22.3087C10.9425 22.3252 10.8897 22.331 10.8373 22.3257C5.88735 21.7257 2.06235 17.4226 2.25922 12.2757C2.36974 9.73393 3.4694 7.33604 5.32347 5.59386C7.17755 3.85167 9.63917 2.90322 12.1829 2.95094C14.7266 2.99865 17.1509 4.03877 18.9384 5.84926C20.7258 7.65975 21.7347 10.0972 21.7498 12.6413V12.6413Z"
                          fill="#EDF1F8"
                        />
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M23.0336 7.92509L20.2024 10.747C19.6399 17.3001 14.1086 22.3907 7.49927 22.3907C6.1399 22.3907 5.0149 22.1751 4.16177 21.7532C3.4774 21.4063 3.19615 21.0407 3.12115 20.9282C3.05909 20.834 3.01911 20.7269 3.00417 20.6151C2.98923 20.5032 2.99972 20.3894 3.03487 20.2822C3.07001 20.175 3.1289 20.0771 3.20714 19.9957C3.28539 19.9144 3.38097 19.8518 3.48677 19.8126C3.50552 19.8032 5.71802 18.9595 7.1524 17.3376C6.26284 16.7042 5.48098 15.9318 4.83677 15.0501C3.5524 13.3063 2.19302 10.2782 3.00865 5.75946C3.03429 5.62512 3.09573 5.5002 3.18649 5.3979C3.27725 5.29559 3.39395 5.21969 3.52427 5.17821C3.65501 5.1354 3.795 5.12938 3.92894 5.16079C4.06287 5.19221 4.18558 5.25986 4.28365 5.35634C4.31177 5.39384 7.43365 8.46884 11.2493 9.46259V8.89071C11.253 8.29607 11.3737 7.70797 11.6047 7.16C11.8357 6.61203 12.1723 6.11492 12.5954 5.69706C13.0185 5.27919 13.5197 4.94875 14.0705 4.72461C14.6213 4.50047 15.2109 4.38701 15.8055 4.39071C16.586 4.40184 17.3502 4.61495 18.0239 5.00926C18.6975 5.40357 19.2575 5.96564 19.6493 6.64071H22.4993C22.6473 6.64025 22.7922 6.68363 22.9157 6.76537C23.0392 6.84712 23.1356 6.96359 23.193 7.10009C23.2471 7.23862 23.2608 7.38962 23.2326 7.53562C23.2044 7.68162 23.1354 7.81665 23.0336 7.92509V7.92509Z"
                          fill="#EDF1F8"
                        />
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.875 3.26562H4.125C3.72718 3.26563 3.34564 3.42366 3.06434 3.70496C2.78304 3.98627 2.625 4.3678 2.625 4.76562V20.5156C2.625 20.9135 2.78304 21.295 3.06434 21.5763C3.34564 21.8576 3.72718 22.0156 4.125 22.0156H19.875C20.2728 22.0156 20.6544 21.8576 20.9357 21.5763C21.217 21.295 21.375 20.9135 21.375 20.5156V4.76562C21.375 4.3678 21.217 3.98627 20.9357 3.70496C20.6544 3.42366 20.2728 3.26563 19.875 3.26562ZM9 17.1406C9 17.3395 8.92098 17.5303 8.78033 17.671C8.63968 17.8116 8.44891 17.8906 8.25 17.8906C8.05109 17.8906 7.86032 17.8116 7.71967 17.671C7.57902 17.5303 7.5 17.3395 7.5 17.1406V11.1406C7.5 10.9417 7.57902 10.7509 7.71967 10.6103C7.86032 10.4696 8.05109 10.3906 8.25 10.3906C8.44891 10.3906 8.63968 10.4696 8.78033 10.6103C8.92098 10.7509 9 10.9417 9 11.1406V17.1406ZM8.25 9.26562C8.0275 9.26562 7.80999 9.19965 7.62498 9.07603C7.43998 8.95241 7.29578 8.77671 7.21064 8.57114C7.12549 8.36558 7.10321 8.13938 7.14662 7.92115C7.19002 7.70292 7.29717 7.50246 7.4545 7.34513C7.61184 7.1878 7.81229 7.08065 8.03052 7.03724C8.24875 6.99383 8.47495 7.01611 8.68052 7.10126C8.88609 7.18641 9.06179 7.3306 9.1854 7.51561C9.30902 7.70061 9.375 7.91812 9.375 8.14062C9.375 8.43899 9.25647 8.72514 9.0455 8.93612C8.83452 9.1471 8.54837 9.26562 8.25 9.26562ZM17.25 17.1406C17.25 17.3395 17.171 17.5303 17.0303 17.671C16.8897 17.8116 16.6989 17.8906 16.5 17.8906C16.3011 17.8906 16.1103 17.8116 15.9697 17.671C15.829 17.5303 15.75 17.3395 15.75 17.1406V13.7656C15.75 13.2683 15.5525 12.7914 15.2008 12.4398C14.8492 12.0882 14.3723 11.8906 13.875 11.8906C13.3777 11.8906 12.9008 12.0882 12.5492 12.4398C12.1975 12.7914 12 13.2683 12 13.7656V17.1406C12 17.3395 11.921 17.5303 11.7803 17.671C11.6397 17.8116 11.4489 17.8906 11.25 17.8906C11.0511 17.8906 10.8603 17.8116 10.7197 17.671C10.579 17.5303 10.5 17.3395 10.5 17.1406V11.1406C10.4995 10.956 10.567 10.7778 10.6898 10.6399C10.8125 10.502 10.9817 10.4142 11.1651 10.3933C11.3485 10.3724 11.5331 10.4199 11.6837 10.5267C11.8343 10.6334 11.9402 10.7919 11.9813 10.9719C12.4887 10.6279 13.0803 10.4286 13.6925 10.3954C14.3047 10.3623 14.9144 10.4965 15.4561 10.7837C15.9977 11.071 16.4509 11.5003 16.767 12.0257C17.083 12.551 17.25 13.1525 17.25 13.7656V17.1406Z"
                          fill="#EDF1F8"
                        />
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.9656 7.18594C21.8795 6.84031 21.7108 6.52072 21.474 6.25457C21.2373 5.98843 20.9395 5.78366 20.6063 5.65781C17.4 4.42031 12.2812 4.42969 12 4.42969C11.7188 4.42969 6.6 4.42031 3.39375 5.65781C3.06051 5.78366 2.76275 5.98843 2.52599 6.25457C2.28923 6.52072 2.12054 6.84031 2.03438 7.18594C1.79063 8.11406 1.5 9.82031 1.5 12.6422C1.5 15.4641 1.79063 17.1703 2.03438 18.0984C2.12054 18.4441 2.28923 18.7637 2.52599 19.0298C2.76275 19.296 3.06051 19.5007 3.39375 19.6266C6.46875 20.8172 11.2875 20.8547 11.9344 20.8547H12.0656C12.7125 20.8547 17.5312 20.8172 20.6063 19.6266C20.9395 19.5007 21.2373 19.296 21.474 19.0298C21.7108 18.7637 21.8795 18.4441 21.9656 18.0984C22.2094 17.1703 22.5 15.4641 22.5 12.6422C22.5 9.82031 22.2094 8.11406 21.9656 7.18594ZM15.2062 12.9516L10.7062 15.9516C10.6466 15.9955 10.5741 16.0185 10.5 16.0172C10.4379 16.0149 10.3771 15.9989 10.3219 15.9703C10.262 15.9391 10.2118 15.892 10.1771 15.8341C10.1423 15.7761 10.1243 15.7097 10.125 15.6422V9.64219C10.1243 9.57465 10.1423 9.50823 10.1771 9.45032C10.2118 9.3924 10.262 9.34524 10.3219 9.31406C10.3817 9.28217 10.449 9.26707 10.5167 9.27037C10.5843 9.27368 10.6499 9.29525 10.7062 9.33281L15.2062 12.3328C15.2585 12.3657 15.3016 12.4114 15.3315 12.4655C15.3614 12.5196 15.377 12.5804 15.377 12.6422C15.377 12.704 15.3614 12.7648 15.3315 12.8189C15.3016 12.873 15.2585 12.9186 15.2062 12.9516Z"
                          fill="#EDF1F8"
                        />
                      </svg>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
